module.exports = "\n<a href=\"https://jepaiemonfps.fr\"  mat-button color=\"primary\" style=\"text-align:right;position:fixed;top:20px;right:20px;\">Je paie mon FPS</a>\n<!-- Fixed navbar -->\n<div class=\"container-fluid text-center pb-5\">\n  <div class=\"global\">\n    <h1>Je conteste mon Forfait Post Stationnement (FPS)</h1>\n    <app-content></app-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main